<template>
    <div class="sch_condition_wrap">
        <div class="checkbox_wrap">
            <label for="chk_all">
                <input id="chk_all" name="cate" type="radio" checked @click="state.type = 0" />
                <em></em>
                <span>전체</span>
            </label>
            <label for="cate_3">
                <input id="cate_3" name="cate" type="radio" @click="state.type = 1" />
                <em></em>
                <span>의심업소</span>
            </label>
            <label for="cate_4">
                <input id="cate_4" name="cate" type="radio" @click="state.type = 2" />
                <em></em>
                <span>알선광고</span>
            </label>
        </div>
    </div>
    <div class="report_group_list" style="max-height: calc(100vh - var(--header_h) - 50px); overflow-y: auto">
        <!-- type별 디자인은 피그마 참고 -->
        <!-- type1 시작 -->
        <div class="report_group">
            <div class="table_group">
                <div class="table_tit">제보전체 건수</div>
                <div class="common_table custom_scroll large" style="width: 800px">
                    <table>
                        <thead>
                            <tr>
                                <th>분류</th>
                                <th>제보 건수</th>
                                <th>대기중 건수</th>
                                <th>접수완료 건수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>의심업소</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.data)) }}</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(31, state.data)) }}</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(32, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>알선광고</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.data)) }}</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(33, state.data)) }}</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(34, state.data)) }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>신고 총 게시물</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.data) + getCntByCn(2, state.data)) }}</td>
                                <td>
                                    {{ CommonUtils.numberFormat(getCntByCn(31, state.data) + getCntByCn(33, state.data)) }}
                                </td>

                                <td>
                                    {{ CommonUtils.numberFormat(getCntByCn(32, state.data) + getCntByCn(34, state.data)) }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 2">
            <div class="table_group">
                <div class="table_tit">의심업소 통계</div>

                <div class="tag_group">
                    <span class="num_tag">
                        학교주변 외
                        <span>{{ CommonUtils.numberFormat(getCntByCn(5, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        학교주변
                        <span>{{ CommonUtils.numberFormat(getCntByCn(6, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        고발/신고 가능
                        <span>{{ CommonUtils.numberFormat(getCntByCn(7, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        고발/신고 불가능
                        <span>{{ CommonUtils.numberFormat(getCntByCn(8, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        총제보
                        <span>{{ CommonUtils.numberFormat(getCntByCn(5, state.data) + getCntByCn(6, state.data)) }}</span>
                    </span>
                </div>

                <div class="common_table custom_scroll large">
                    <table>
                        <colgroup>
                            <col style="width: calc(100% / 3)" />
                            <col style="width: calc(100% / 3)" />
                            <col style="width: calc(100% / 3)" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>분류</th>
                                <th>신고여부</th>
                                <th>게시물 건수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>학교주변 외</td>
                                <td>가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>학교주변 외</td>
                                <td>불가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>학교주변</td>
                                <td>가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>학교주변</td>
                                <td>불가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.data)) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 2">
            <div class="tit_tag">학교주변 외</div>
            <div class="_flex large">
                <div class="table_group">
                    <div class="table_tit">학교주변 외 신고가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>국민신문고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>방송통신심의위원회</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(3, state.dataDetail1)) }}</td>
                                </tr>
                                <tr class="tfoot">
                                    <td>신고 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail1) +
                                                    getCntByCn(2, state.dataDetail1) +
                                                    getCntByCn(3, state.dataDetail1),
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>고발</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(4, state.dataDetail1)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>신고/고발 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail1) +
                                                    getCntByCn(2, state.dataDetail1) +
                                                    getCntByCn(3, state.dataDetail1) +
                                                    getCntByCn(4, state.dataDetail1),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="table_tit">고발/신고불가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>내용부족</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(5, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>주소 불명확</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(6, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>온라인 모니터링 불가</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(7, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>게시판 오신고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(8, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>중복</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.dataDetail1)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(5, state.dataDetail1) +
                                                    getCntByCn(6, state.dataDetail1) +
                                                    getCntByCn(7, state.dataDetail1) +
                                                    getCntByCn(8, state.dataDetail1) +
                                                    getCntByCn(9, state.dataDetail1) +
                                                    getCntByCn(10, state.dataDetail1),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="_flex small">
                <div class="table_tit">학교주변 외 업종분류</div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>마사지</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>키스방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>휴게텔</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>오피</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.dataDetail1)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>다방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매매알선포털사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>출장마사지 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매수자 커뮤니티</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.dataDetail1)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SNS</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(21, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>안마 및 스파</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(22, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>페티쉬</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(24, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>해외 성매매 알선</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(25, state.dataDetail1)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(23, state.dataDetail1)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 2">
            <div class="tit_tag">학교주변</div>
            <div class="_flex large">
                <div class="table_group">
                    <div class="table_tit">학교주변 신고가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>국민신문고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>방송통신심의위원회</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(3, state.dataDetail2)) }}</td>
                                </tr>
                                <tr class="tfoot">
                                    <td>신고 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail2) +
                                                    getCntByCn(2, state.dataDetail2) +
                                                    getCntByCn(3, state.dataDetail2),
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>고발</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(4, state.dataDetail2)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>신고/고발 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail2) +
                                                    getCntByCn(2, state.dataDetail2) +
                                                    getCntByCn(3, state.dataDetail2) +
                                                    getCntByCn(4, state.dataDetail2),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="table_tit">고발/신고불가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>내용부족</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(5, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>주소 불명확</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(6, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>온라인 모니터링 불가</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(7, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>게시판 오신고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(8, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>중복</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.dataDetail2)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(5, state.dataDetail2) +
                                                    getCntByCn(6, state.dataDetail2) +
                                                    getCntByCn(7, state.dataDetail2) +
                                                    getCntByCn(8, state.dataDetail2) +
                                                    getCntByCn(9, state.dataDetail2) +
                                                    getCntByCn(10, state.dataDetail2),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="_flex small">
                <div class="table_tit">학교주변 업종분류</div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>마사지</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>키스방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>휴게텔</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>오피</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.dataDetail2)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>다방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매매알선포털사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>출장마사지 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매수자 커뮤니티</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.dataDetail2)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SNS</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(21, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>안마 및 스파</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(22, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>페티쉬</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(24, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>해외 성매매 알선</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(25, state.dataDetail2)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(23, state.dataDetail2)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- type4 시작 -->
        <div class="report_group" v-if="state.type !== 1">
            <div class="table_group">
                <div class="table_tit">알선 광고 통계</div>

                <div class="tag_group">
                    <span class="num_tag">
                        온라인 알선광고
                        <span>{{ CommonUtils.numberFormat(getCntByCn(13, state.data) + getCntByCn(14, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        지면광고
                        <span>{{ CommonUtils.numberFormat(getCntByCn(15, state.data) + getCntByCn(16, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        불법 옥외 광고물
                        <span>{{ CommonUtils.numberFormat(getCntByCn(17, state.data) + getCntByCn(18, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        기타
                        <span>{{ CommonUtils.numberFormat(getCntByCn(19, state.data) + getCntByCn(20, state.data)) }}</span>
                    </span>
                    <span class="num_tag">
                        고발/신고 가능
                        <span>
                            {{
                                CommonUtils.numberFormat(
                                    getCntByCn(13, state.data) + getCntByCn(15, state.data) + getCntByCn(17, state.data) + getCntByCn(19, state.data),
                                )
                            }}
                        </span>
                    </span>
                    <span class="num_tag">
                        고발/신고 불가능
                        <span>
                            {{
                                CommonUtils.numberFormat(
                                    getCntByCn(14, state.data) + getCntByCn(16, state.data) + getCntByCn(18, state.data) + getCntByCn(20, state.data),
                                )
                            }}
                        </span>
                    </span>
                    <span class="num_tag">
                        총제보
                        <span>
                            {{
                                CommonUtils.numberFormat(
                                    getCntByCn(13, state.data) +
                                        getCntByCn(15, state.data) +
                                        getCntByCn(17, state.data) +
                                        getCntByCn(19, state.data) +
                                        getCntByCn(14, state.data) +
                                        getCntByCn(16, state.data) +
                                        getCntByCn(18, state.data) +
                                        getCntByCn(20, state.data),
                                )
                            }}
                        </span>
                    </span>
                </div>

                <div class="common_table custom_scroll large">
                    <table>
                        <colgroup>
                            <col style="width: calc(100% / 3)" />
                            <col style="width: calc(100% / 3)" />
                            <col style="width: calc(100% / 3)" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>게시물 옵션</th>
                                <th>신고여부</th>
                                <th>게시물 건수</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>온라인 알선광고</td>
                                <td>가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>온라인 알선광고</td>
                                <td>불가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>지면광고</td>
                                <td>가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>지면광고</td>
                                <td>불가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.data)) }}</td>
                            </tr>

                            <tr>
                                <td>불법 옥외 광고물</td>
                                <td>가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>불법 옥외 광고물</td>
                                <td>불가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>기타</td>
                                <td>가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.data)) }}</td>
                            </tr>
                            <tr>
                                <td>기타</td>
                                <td>불가능</td>
                                <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.data)) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 1">
            <div class="tit_tag">온라인 알선광고</div>
            <div class="_flex large">
                <div class="table_group">
                    <div class="table_tit">온라인 알선광고 신고가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>국민신문고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>방송통신심의위원회</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(3, state.dataDetail3)) }}</td>
                                </tr>
                                <tr class="tfoot">
                                    <td>신고 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail3) +
                                                    getCntByCn(2, state.dataDetail3) +
                                                    getCntByCn(3, state.dataDetail3),
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>고발</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(4, state.dataDetail3)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>신고/고발 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail3) +
                                                    getCntByCn(2, state.dataDetail3) +
                                                    getCntByCn(3, state.dataDetail3) +
                                                    getCntByCn(4, state.dataDetail3),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="table_tit">고발/신고불가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>내용부족</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(5, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>주소 불명확</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(6, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>온라인 모니터링 불가</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(7, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>게시판 오신고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(8, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>중복</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.dataDetail3)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(5, state.dataDetail3) +
                                                    getCntByCn(6, state.dataDetail3) +
                                                    getCntByCn(7, state.dataDetail3) +
                                                    getCntByCn(8, state.dataDetail3) +
                                                    getCntByCn(9, state.dataDetail3) +
                                                    getCntByCn(10, state.dataDetail3),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="_flex small">
                <div class="table_tit">온라인 알선광고 업종분류</div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>마사지</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>키스방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>휴게텔</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>오피</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.dataDetail3)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>다방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매매알선포털사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>출장마사지 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매수자 커뮤니티</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.dataDetail3)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SNS</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(21, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>안마 및 스파</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(22, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>페티쉬</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(24, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>해외 성매매 알선</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(25, state.dataDetail3)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(23, state.dataDetail3)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 1">
            <div class="tit_tag">지면광고</div>
            <div class="_flex large">
                <div class="table_group">
                    <div class="table_tit">지면광고 신고가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>국민신문고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>방송통신심의위원회</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(3, state.dataDetail4)) }}</td>
                                </tr>
                                <tr class="tfoot">
                                    <td>신고 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail4) +
                                                    getCntByCn(2, state.dataDetail4) +
                                                    getCntByCn(3, state.dataDetail4),
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>고발</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(4, state.dataDetail4)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>신고/고발 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail4) +
                                                    getCntByCn(2, state.dataDetail4) +
                                                    getCntByCn(3, state.dataDetail4) +
                                                    getCntByCn(4, state.dataDetail4),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="table_tit">고발/신고불가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>내용부족</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(5, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>주소 불명확</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(6, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>온라인 모니터링 불가</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(7, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>게시판 오신고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(8, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>중복</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.dataDetail4)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(5, state.dataDetail4) +
                                                    getCntByCn(6, state.dataDetail4) +
                                                    getCntByCn(7, state.dataDetail4) +
                                                    getCntByCn(8, state.dataDetail4) +
                                                    getCntByCn(9, state.dataDetail4) +
                                                    getCntByCn(10, state.dataDetail4),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="_flex small">
                <div class="table_tit">지면광고 업종분류</div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>마사지</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>키스방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>휴게텔</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>오피</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.dataDetail4)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>다방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매매알선포털사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>출장마사지 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매수자 커뮤니티</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.dataDetail4)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SNS</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(21, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>안마 및 스파</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(22, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>페티쉬</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(24, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>해외 성매매 알선</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(25, state.dataDetail4)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(23, state.dataDetail4)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 1">
            <div class="tit_tag">불법옥외 광고물</div>
            <div class="_flex large">
                <div class="table_group">
                    <div class="table_tit">불법옥외 광고물 신고가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>국민신문고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>방송통신심의위원회</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(3, state.dataDetail5)) }}</td>
                                </tr>
                                <tr class="tfoot">
                                    <td>신고 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail5) +
                                                    getCntByCn(2, state.dataDetail5) +
                                                    getCntByCn(3, state.dataDetail5),
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>고발</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(4, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>신고/고발 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail5) +
                                                    getCntByCn(2, state.dataDetail5) +
                                                    getCntByCn(3, state.dataDetail5) +
                                                    getCntByCn(4, state.dataDetail5),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="table_tit">고발/신고불가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>내용부족</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(5, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>주소 불명확</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(6, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>온라인 모니터링 불가</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(7, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>게시판 오신고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(8, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>중복</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(5, state.dataDetail5) +
                                                    getCntByCn(6, state.dataDetail5) +
                                                    getCntByCn(7, state.dataDetail5) +
                                                    getCntByCn(8, state.dataDetail5) +
                                                    getCntByCn(9, state.dataDetail5) +
                                                    getCntByCn(10, state.dataDetail5),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="_flex small">
                <div class="table_tit">불법옥외 광고물 업종분류</div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>마사지</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>키스방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>휴게텔</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>오피</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>다방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매매알선포털사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>출장마사지 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매수자 커뮤니티</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SNS</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(21, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>안마 및 스파</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(22, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>페티쉬</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(24, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>해외 성매매 알선</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(25, state.dataDetail5)) }}</td>
                                </tr>

                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(23, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="report_group" v-if="state.type !== 1">
            <div class="tit_tag">기타</div>
            <div class="_flex large">
                <div class="table_group">
                    <div class="table_tit">기타 신고가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>국민신문고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(1, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>방송통신심의위원회</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(2, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(3, state.dataDetail6)) }}</td>
                                </tr>
                                <tr class="tfoot">
                                    <td>신고 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail6) +
                                                    getCntByCn(2, state.dataDetail6) +
                                                    getCntByCn(3, state.dataDetail6),
                                            )
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>고발</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(4, state.dataDetail6)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>신고/고발 총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(1, state.dataDetail6) +
                                                    getCntByCn(2, state.dataDetail6) +
                                                    getCntByCn(3, state.dataDetail6) +
                                                    getCntByCn(4, state.dataDetail6),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="table_tit">고발/신고불가능</div>
                    <div class="common_table custom_scroll large">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>내용부족</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(5, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>주소 불명확</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(6, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>온라인 모니터링 불가</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(7, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>게시판 오신고</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(8, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>중복</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(9, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(10, state.dataDetail6)) }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>총 게시물</td>
                                    <td>
                                        {{
                                            CommonUtils.numberFormat(
                                                getCntByCn(5, state.dataDetail6) +
                                                    getCntByCn(6, state.dataDetail6) +
                                                    getCntByCn(7, state.dataDetail6) +
                                                    getCntByCn(8, state.dataDetail6) +
                                                    getCntByCn(9, state.dataDetail6) +
                                                    getCntByCn(10, state.dataDetail6),
                                            )
                                        }}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="_flex small">
                <div class="table_tit">기타 업종분류</div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>마사지</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(11, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(12, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>키스방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(13, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>휴게텔</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(14, state.dataDetail6)) }}</td>
                                </tr>
                                <tr>
                                    <td>오피</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(15, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>다방</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(16, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매매알선포털사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(17, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>출장마사지 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(18, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>유흥주점 알선 사이트</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(19, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>성매수자 커뮤니티</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(20, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_group">
                    <div class="common_table custom_scroll small">
                        <table>
                            <thead>
                                <tr>
                                    <th>분류</th>
                                    <th>게시물 건수</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>SNS</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(21, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>안마 및 스파</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(22, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>페티쉬</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(24, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>해외 성매매 알선</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(25, state.dataDetail5)) }}</td>
                                </tr>
                                <tr>
                                    <td>기타</td>
                                    <td>{{ CommonUtils.numberFormat(getCntByCn(23, state.dataDetail5)) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" config>
    import { userStore, globalStore, reactive, watch, apiService, onMounted, types, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            startDate: { type: String, required: true },
            endDate: { type: String, required: true },
        },
        components: {},
        setup(props: any) {
            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                data: [] as Array<types.StatisticsVOForApi>,
                dataDetail1: [] as Array<types.StatisticsVOForApi>,
                dataDetail2: [] as Array<types.StatisticsVOForApi>,
                dataDetail3: [] as Array<types.StatisticsVOForApi>,
                dataDetail4: [] as Array<types.StatisticsVOForApi>,
                dataDetail5: [] as Array<types.StatisticsVOForApi>,
                dataDetail6: [] as Array<types.StatisticsVOForApi>,

                type: 0 as 0 | 1 | 2,
            });

            onMounted(() => {
                state.startDate = props.startDate;
                state.endDate = props.endDate;
                getCommon();
            });

            watch(props, () => {
                state.startDate = props.startDate;
                state.endDate = props.endDate;
                getCommon();
            });

            watch(
                () => state.type,
                () => {
                    selectType();
                },
            );

            const selectType = () => {
                switch (state.type) {
                    case 0:
                        {
                            getDetail(1, 0, null);
                            getDetail(1, 1, null);
                            getDetail(2, null, 1);
                            getDetail(2, null, 2);
                            getDetail(2, null, 3);
                            getDetail(2, null, 4);
                        }
                        break;
                    case 1:
                        {
                            getDetail(1, 0, null);
                            getDetail(1, 1, null);
                        }
                        break;
                    case 2:
                        {
                            getDetail(2, null, 1);
                            getDetail(2, null, 2);
                            getDetail(2, null, 3);
                            getDetail(2, null, 4);
                        }
                        break;
                }
            };

            const getCommon = async () => {
                const param: types.ReqParamForAdmin = {
                    page: 0,
                    size: 0,
                    searchType: "",
                    searchText: "",
                    startDate: state.startDate,
                    endDate: state.endDate,
                };
                const res: types.ResStatisticsForReport = await apiService.statistics.reportCommon(param);
                if (res.returnCode === 0) {
                    state.data = res.list;
                    selectType();
                } else {
                    state.data = [];
                    selectType();
                }
            };

            const getDetail = async (type: 1 | 2, isSchool: 1 | 0 | null, adType: 1 | 2 | 3 | 4 | null) => {
                const param: types.ReqStatisticsForReport = {
                    startDate: state.startDate,
                    endDate: state.endDate,
                    adType: adType,
                    isSchool: isSchool,
                };
                const res: types.ResStatisticsForReport = await apiService.statistics.reportDetail(type, param);
                if (res.returnCode === 0) {
                    if (isSchool === 0) state.dataDetail1 = res.list;
                    else if (isSchool === 1) state.dataDetail2 = res.list;
                    else if (adType === 1) state.dataDetail3 = res.list;
                    else if (adType === 2) state.dataDetail4 = res.list;
                    else if (adType === 3) state.dataDetail5 = res.list;
                    else if (adType === 4) state.dataDetail6 = res.list;
                } else {
                    if (isSchool === 0) state.dataDetail1 = [];
                    else if (isSchool === 1) state.dataDetail2 = [];
                    else if (adType === 1) state.dataDetail3 = [];
                    else if (adType === 2) state.dataDetail4 = [];
                    else if (adType === 3) state.dataDetail5 = [];
                    else if (adType === 4) state.dataDetail6 = [];
                }
            };

            const getCntByCn = (cn: number, list: Array<types.StatisticsVOForApi>) => {
                return list.find((item) => item.cn === cn)?.cnt ?? 0;
            };

            return { state, CommonUtils, getCntByCn };
        },
    };
</script>

<style scoped>
    .common_table {
        overflow-y: auto !important;
    }
</style>
